<div mat-dialog-content>
    <lgv-loading-indicator *ngIf="isUploading$ | async"></lgv-loading-indicator>

    <h4 *ngIf="isAddMode">Add Vault Document</h4>
    <h4 *ngIf="isEditMode">Edit Vault Document</h4>
    <h4 *ngIf="isUploadMode">Upload Vault Document</h4>
    <div class="Vert-15"></div>

    <ng-container *ngIf="isAddMode || isEditMode">
        <form [formGroup]="_vaultForm">
            <div class="row">
                <mat-form-field appearance="outline" floatLabel="always" class="col-12">
                    <mat-label>Name</mat-label>
                    <input type="text" matInput formControlName="name">
                </mat-form-field>
                <mat-form-field appearance="outline" floatLabel="always" class="col-12">
                    <mat-label>Description</mat-label>
                    <input type="text" matInput formControlName="description">
                </mat-form-field>
                <mat-slide-toggle formControlName="isInternal">
                    Internal
                </mat-slide-toggle>
            </div>
        </form>
    </ng-container>

    <ng-container *ngIf="isAddMode || isUploadMode">
        <div class="Vert-15"></div>
        <div *ngIf="!selectedFiles">
            <button class="btn btn-secondary" type="button" (click)="fileInput.click()">Choose File</button>
            <input hidden="true" class="btn btn-secondary" type="file" #fileInput multiple
                   accept="image/*, .doc, application/pdf, .DOC, .DOCM, .DOCX, .DOT, .DOTM, .DOTX, .RTF, .TXT, .ODT, .OTT, .XLSX, .XLSB, .XLS2003, .XLT, .XLTX, .XLTM, .XLAM, .ODS, .TSV, .CSV, .XLS, .XLSM, .PDF, .XPS, .MSG, .EML, .EMLX"
                   (change)="fileChangeEvent($event)" required>
        </div>
        <div class="Vert-15"></div>
        <div *ngIf="selectedFiles?.length > 0">
            <ul *ngFor="let selectedFile of selectedFiles">
                <li>{{selectedFile.name}}</li>
            </ul>
        </div>
        <div *ngIf="!selectedFiles">
            No file selected.
        </div>
    </ng-container>

    <div class="Vert-15"></div>

    <div class="lgv-progress-bar" *ngIf="isUploading$ | async">
        <mat-progress-bar mode="determinate" [value]="uploadProgress$ | async"></mat-progress-bar>
        <div>{{ (uploadProgress$ | async) >= 100 ? 'Processing...' : 'Uploading...' }}</div>
    </div>

    <div class="Vert-15"></div>
    <div class="row">
        <div class="col-12" align="end">
            <button mat-button class="btn btn-primary float-end" (click)="onSubmit()" [disabled]="!readyToSubmit || (isUploading$ | async)">
                <span *ngIf="isAddMode">Add</span>
                <span *ngIf="isEditMode">Update</span>
                <span *ngIf="isUploadMode">Upload</span>
            </button>
            <button mat-stroked-button (click)="onCancel()" class="btn btn-secondary float-end" style="margin-right:10px;">Cancel</button>
        </div>
    </div>
</div>
